module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8696/img/cta-blobs.png"